import React, { useContext } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import {AuthContext, AuthProvider, AdminCompanyProvider, UserCompanyProvider, SiteSelectionProvider} from '@context';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ReactModal from "react-modal";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5분
            retry: (failureCount, error) => {
                // 권한 오류는 재시도 불필요
                if (error?.status === 403 || error?.status === 401) return false;
                return failureCount < 2;
            },
            // 403 에러를 throw → PermissionErrorBoundary가 중앙에서 처리
            throwOnError: (error) => error?.status === 403,
        },
    },
});

// 로그인 사용자가 바뀌면 내부 Context를 새로 마운트해 이전 사용자 데이터를 초기화
function UserScopedProviders({ children }) {
    const { auth } = useContext(AuthContext);
    const scopeKey = auth.isAuthenticated ? (auth.userId ?? 'authenticated') : 'guest';

    return (
        <AdminCompanyProvider key={scopeKey}>
            <UserCompanyProvider key={scopeKey}>
                <SiteSelectionProvider key={scopeKey}>
                    {children}
                </SiteSelectionProvider>
            </UserCompanyProvider>
        </AdminCompanyProvider>
    );
}

function App() {
    ReactModal.setAppElement("#root");
    return (
        <QueryClientProvider client={queryClient}>
            <Router>
                <AuthProvider>
                    <UserScopedProviders>
                        <AppRoutes/>
                        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false}
                                        closeOnClick/>
                    </UserScopedProviders>
                </AuthProvider>
            </Router>
        </QueryClientProvider>
    );
}

export default App;
